export const enum TWILIO_INTEGRATION_TABS_VALUES{
  CUSTOMER_PROFILE,
  BRAND_AND_CAMPAIGN,
  PHONE_NUMBERS,
};

export const TWILIO_INTEGRATION_TABS: Array<Readonly<{name: string, value: number}>> = [
  { name: 'Customer Profile', value: TWILIO_INTEGRATION_TABS_VALUES.CUSTOMER_PROFILE },
  { name: 'Brand and Campaign', value: TWILIO_INTEGRATION_TABS_VALUES.BRAND_AND_CAMPAIGN },
  { name: 'Phone Numers', value: TWILIO_INTEGRATION_TABS_VALUES.PHONE_NUMBERS },
];

